import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished, loadingFailed } from "@itk/typescript-utils";
import { Model_EmployeeGet as EmployeeGet } from "src/backend/openapi/v1";
import { CustomerPortalContactGet } from "./contact-info-types";

export enum Action {
  GetEmployeeRequest = "@@ITK:SRC:PAGES:CONTACT:CONTACT-INFO-STORE.TS:ACTION:GETEMPLOYEEREQUEST",
  GetEmployeeSuccess = "@@ITK:SRC:PAGES:CONTACT:CONTACT-INFO-STORE.TS:ACTION:GETEMPLOYEESUCCESS",

  GetCustomerPortalContactRequest = "@@ITK:SRC:PAGES:CONTACT:CONTACT-INFO-STORE.TS:ACTION:GETCUSTOMERPORTALCONTACTREQUEST",
  GetCustomerPortalContactSuccess = "@@ITK:SRC:PAGES:CONTACT:CONTACT-INFO-STORE.TS:ACTION:GETCUSTOMERPORTALCONTACTSUCCESS",
  GetCustomerPortalContactFail = "@@ITK:SRC:PAGES:CONTACT:CONTACT-INFO-STORE.TS:ACTION:GETCUSTOMERPORTALCONTACTFAIL",

  PostCustomerportalEmployeePictureListRequest = "@@ITK:SRC:PAGES:CONTACT:CONTACT-INFO-STORE.TS:ACTION:POSTCUSTOMERPORTALEMPLOYEEPICTURELISTREQUEST",
  PostCustomerportalEmployeePictureListSuccess = "@@ITK:SRC:PAGES:CONTACT:CONTACT-INFO-STORE.TS:ACTION:POSTCUSTOMERPORTALEMPLOYEEPICTURELISTSUCCESS",
  PostCustomerportalEmployeePictureListFail = "@@ITK:SRC:PAGES:CONTACT:CONTACT-INFO-STORE.TS:ACTION:POSTCUSTOMERPORTALEMPLOYEEPICTURELISTFAIL",

  Clear = "@@ITK:SRC:PAGES:CONTACT:CONTACT-INFO-STORE.TS:ACTION:CLEAR"
}

type EmployeeState = {
  employeedetails: Loading<EmployeeGet>;
  contact: Loading<CustomerPortalContactGet>;
  loadingEmployeesPicture: Loading<Record<string, string>>;
  loadingEmployeesPictureCache: Record<string, string>;
};

const initialState: EmployeeState = {
  employeedetails: loadingNotStarted,
  contact: loadingNotStarted,
  loadingEmployeesPicture: loadingNotStarted,
  loadingEmployeesPictureCache: {}
};

export const employeeActions = {
  getEmployeeRequest: (employeeId: string) => actionCreator(Action.GetEmployeeRequest, { employeeId }),
  getEmployeeSuccess: (data: EmployeeGet) => actionCreator(Action.GetEmployeeSuccess, { data }),

  getCustomerPortalContactRequest: (customerId: string) => actionCreator(Action.GetCustomerPortalContactRequest, { customerId }),
  getCustomerPortalContactSuccess: (data: CustomerPortalContactGet) => actionCreator(Action.GetCustomerPortalContactSuccess, { data }),
  getCustomerPortalContactFail: () => actionCreator(Action.GetCustomerPortalContactFail),

  postCustomerportalEmployeePictureListRequest: (employeeIds: string[]) => actionCreator(Action.PostCustomerportalEmployeePictureListRequest, { employeeIds }),
  postCustomerportalEmployeePictureListSuccess: (data: Record<string, string>) => actionCreator(Action.PostCustomerportalEmployeePictureListSuccess, { data }),
  postCustomerportalEmployeePictureListFail: () => actionCreator(Action.PostCustomerportalEmployeePictureListFail),

  clear: () => actionCreator(Action.Clear)
};

export const employeeInformationReducer = (state = initialState, action: ActionReturnType<typeof employeeActions>): EmployeeState => {
  switch (action.type) {
    case Action.GetEmployeeRequest:
      return { ...state, employeedetails: loadingIsLoading };
    case Action.GetEmployeeSuccess:
      return { ...state, employeedetails: loadingFinished(action.payload.data) };

    case Action.GetCustomerPortalContactRequest:
      return { ...state, contact: loadingIsLoading };
    case Action.GetCustomerPortalContactSuccess:
      return { ...state, contact: loadingFinished(action.payload.data) };
    case Action.GetCustomerPortalContactFail:
      return { ...state, contact: loadingFailed };

    case Action.PostCustomerportalEmployeePictureListRequest:
      return { ...state, loadingEmployeesPicture: loadingIsLoading };

    case Action.PostCustomerportalEmployeePictureListSuccess:
      return { ...state, loadingEmployeesPicture: loadingFinished(action.payload.data), loadingEmployeesPictureCache: { ...state.loadingEmployeesPictureCache, ...action.payload.data } };
    case Action.PostCustomerportalEmployeePictureListFail:
      return { ...state, loadingEmployeesPicture: loadingNotStarted };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
